<template>
  <div>
    <v-form v-model="isFormValid" ref="form">
      <!-- Family Discount -->
      <AdminFieldWrapper label="Family Discount">
        <AdminInputPercentage
          :value="entity.family_discount"
          label="Family Discount"
          @change="$emit('update', { family_discount: Number($event) })"
          v-bind="globalFieldAttrs"
        />
      </AdminFieldWrapper>
      <v-text-field
        v-for="{ fieldName, label, rules } of fields"
        :key="`${entity.id}-${fieldName}`"
        :value="entity[fieldName] || ''"
        :rules="rules"
        :label="label"
        @change="$emit('update', { [fieldName]: $event })"
        v-bind="globalFieldAttrs"
      />
      <v-textarea
        :value="entity.notes"
        label="Customer Notes"
        auto-grow
        rows="4"
        hide-details
        v-bind="globalFieldAttrs"
        @change="$emit('update', { notes: $event })"
      />
    </v-form>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import CustomerModel from '@/models/CustomerModel'
import ValidationRules from '@/constants/ValidationRules'

import _get from 'lodash/get'

import AdminInputPercentage from '@/components/AdminInputPercentage'
import AdminFieldWrapper from '@/components/AdminFieldWrapper'
export default {
  name: 'AdminEditCustomerForm',
  components: {
    AdminFieldWrapper,
    AdminInputPercentage,
  },
  props: {
    entity: {
      type: Object,
      require: true,
      default: () => {},
    },
  },
  data() {
    return {
      isFormValid: false,
      ValidationRules,
      CustomerModel,
      fields: [
        { label: 'Last Name', fieldName: 'last_name' },
        { label: 'First Name', fieldName: 'first_name' },
        {
          label: 'Email',
          fieldName: 'email',
          rules: [ValidationRules.requiredString, ValidationRules.emailRule],
        },
        {
          label: 'Phone',
          fieldName: 'phone',
          rules: [ValidationRules.phoneRule],
        },
        {
          label: 'Address',
          fieldName: 'street',
        },
        { label: 'Payment Service', fieldName: 'payment_service' },
        { label: 'Payment Handle', fieldName: 'payment_handle' },
      ],
    }
  },
  methods: {
    _get,
  },
  mounted() {
    this.$refs.form.validate()
  },
  computed: {
    ...mapGetters('shop', ['getFulfillmentOptions', 'getFulfillmentSlotsList']),
    globalFieldAttrs() {
      const defaults = { outlined: true, dense: true }
      return { ...defaults }
    },
  },
  watch: {
    isFormValid(validity) {
      this.$emit('form:valid', validity)
    },
  },
}
</script>
